// extracted by mini-css-extract-plugin
export default {"body":"home_body__pwS0M"};